import { container } from "tsyringe";
import ConfigApi from "api/clapaction/projects/[id]/config/ConfigApi";
import ProjectConfigRequestResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigRequestResource";
import ProjectConfigResponseResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigResponseResource";
import toValidationError from "utils/toValidationError";

export default class ConfigService {
	private api: ConfigApi = container.resolve(ConfigApi);

	/**
	 * @description Get by project id
	 */
	public async getByProjectId(projectId: string): Promise<ProjectConfigResponseResource> {
		return this.api.getByProjectId(projectId).catch(toValidationError);
	}

	/**
	 * @description Get by project config id
	 */
	public async getByProjectConfigId(projectId: string, projectConfigId: string): Promise<ProjectConfigResponseResource> {
		return this.api.getByProjectConfigId(projectId, projectConfigId).catch(toValidationError);
	}

	/**
	 * @description Create a new project config, or get the existing one
	 */
	public async create(projectId: string, request: ProjectConfigRequestResource): Promise<ProjectConfigResponseResource> {
		return this.api.create(projectId, request).catch(toValidationError);
	}

	/**
	 * @description Update a project config
	 */
	public async update(projectId: string, projectConfigId: string, request: ProjectConfigRequestResource): Promise<ProjectConfigResponseResource> {
		return this.api.update(projectId, projectConfigId, request).catch(toValidationError);
	}

	/**
	 * @description Delete a project config
	 */
	public async delete(projectId: string, projectConfigId: string): Promise<void> {
		return this.api.delete(projectId, projectConfigId).catch(toValidationError);
	}

	/**
	 * @description Publish a project
	 */
	public async publish(projectId: string): Promise<void> {
		return this.api.publish(projectId).catch(toValidationError);
	}
}
